// document.addEventListener("bundler:loaded", function (e) {
//     setTimeout(() => {
//       const selectedBundleItemsEl = document.querySelector(
//         ".bndlr-mnm-second-container"
//       );
//       const selectedBundleToggleEl = document.querySelector(
//         ".bndlr-mnm-selected-products-title.bndlr-toggle"
//       );
  
//       const allProducts = document.querySelectorAll(
//         ".bndlr-product.bndlr-mix-and-match.bndlr-no-plus-sign"
//       );
  
//       const currentBundleEl = document.querySelector(
//         ".bndlr-mnm-selected-products.bndlr-toggle"
//       );
  
//       if (selectedBundleItemsEl) {
//         selectedBundleToggleEl.addEventListener("click", function (e) {
//             console.log("click.");
//           selectedBundleItemsEl.classList.toggle("open");
//         });
//       }
  
//       if (allProducts && currentBundleEl) {
//         allProducts.forEach((product) => {
//           product.addEventListener("click", function (e) {
//             console.log("click..");
//             if (currentBundleEl.childNodes.length >= 2) {
//               selectedBundleItemsEl.classList.add("open");
//             }
//           });
//         });
//       }
//     }, 1500);
//   });
  

document.addEventListener("bundler:loaded", function () {
  setTimeout(() => {

    const allProducts = document.querySelectorAll(
      ".bndlr-product.bndlr-mix-and-match.bndlr-no-plus-sign"
    );

    const currentBundleEl = document.querySelector(
      ".bndlr-mnm-selected-products.bndlr-toggle"
    );


    // Product click logic
    if (allProducts && currentBundleEl && selectedBundleItemsEl) {
      allProducts.forEach((product) => {
        product.addEventListener("click", function () {
          if (currentBundleEl.childNodes.length >= 2) {
            selectedBundleItemsEl.classList.add("open");
          }
        });
      });
    }
  }, 1500);
});

 // Document-level click listener for title toggle
 document.addEventListener("click", function (e) {
  const selectedBundleItemsEl = document.querySelector(
    ".bndlr-mnm-second-container"
  );
  if (e.target.classList.contains("bndlr-mnm-selected-products-title") &&
      e.target.classList.contains("bndlr-toggle")) {
    if (selectedBundleItemsEl) {
      selectedBundleItemsEl.classList.toggle("open");
    }
  }
});